export default __webpack_public_path__ + "static/gustolle-c7c050c06cf2d793f73af72593e29e08.woff2";